import { Component, OnInit, Input, EventEmitter, Output, Optional, Self } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NgControl, NgForm } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import dayjs from 'dayjs';

@Component({
    selector: 'datetime-picker',
    templateUrl: './datetime-picker.component.html',
    styleUrls: ['./datetime-picker.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class DatetimePickerComponent implements OnInit, ControlValueAccessor {
  _dateTime = dayjs();
  _time: string;
  _date: string;

  get model() {
    return this._dateTime.toDate();
  }

  @Input() set model(v: Date | string) {
    this._dateTime = dayjs(v || dayjs()).second(0).millisecond(0);
    this.resetTimeStrings();
  }

  @Input() required: boolean;
  @Input() name: string;

  @Output() modelChange = new EventEmitter<Date>();

  constructor(@Self() @Optional() private control: NgControl) {
    control.valueAccessor = this;
  }

  ngOnInit() {
  }

  public dateChange(date: MatDatepickerInputEvent<any>) {
    const dayjsDate = dayjs(date.value).hour(this._dateTime.hour()).minute(this._dateTime.minute()).second(0).millisecond(0);

    const newDate = dayjsDate.toDate();
    this.modelChange.emit(newDate);
    this.writeValue(newDate);
  }

  public timeChange(time: string) {
    const splitTime = time.split(':');
    const hour = splitTime[0];
    const minute = splitTime[1];

    this._dateTime = this._dateTime.hour(parseInt(hour)).minute(parseInt(minute)).second(0).millisecond(0);

    const newDate = this._dateTime.toDate();
    this.modelChange.emit(newDate);
    this.writeValue(newDate);
  }

  resetTimeStrings() {
    this._date = this._dateTime.format();
    this._time = this._dateTime.format("HH:mm");
  }

  onChange: (_: any) => void = (_: any) => {};
  onTouched: () => void = () => {};

  updateChanges() {
    this.onChange(this.model);
  }

  writeValue(value: Date): void {
    this.model = value;
    this.updateChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}